/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectContext, selectPreferences } from './ContextSelector';

export const defaultValues = {
    cmData: {
        isIrisFallBackEnabled: false,
    },
    page: {},
    seoMetaData: {},
    breadcrumbPath: [],
    deviceType: {},
    irisS1Targter: [],
    cmPageInclusionList: [],
};

export const selectCMData = (state) => state?.cmData || defaultValues.cmData;

export const selectIsIrisFallBackEnabled = createSelector(selectCMData, (cmData) =>
    get(cmData, 'isIrisFallBackEnabled', defaultValues.cmData.isIrisFallBackEnabled)
);

export const selectCMPageData = createSelector(selectCMData, (cmData) =>
    get(cmData, 'page', defaultValues.page)
);

export const selectCMSeoMeta = createSelector(selectCMPageData, (cmData) =>
    get(cmData, 'seoMetaData', defaultValues.seoMetaData)
);

export const selectCMBreadCrumbData = createSelector(selectCMPageData, (cmData) =>
    get(cmData, 'breadcrumbPath', defaultValues.breadcrumbPath)
);

export const selectReqPagePath = createSelector([selectContext], (context) =>
    get(context, 'requestUrl', false)
);

export const selectHostName = createSelector([selectContext], (context) =>
    get(context, 'hostname', false)
);

export const getDeviceType = createSelector([selectContext], (context) =>
    get(context, 'deviceType', defaultValues.deviceType)
);

export const selectIrisS1Targeter = (state) =>
    get(state, 'irisS1Targter', defaultValues.irisS1Targter);

export const selectCmPageInclusionList = createSelector([selectPreferences], (preferences) =>
    get(preferences, 'cmPageInclusionList', defaultValues.cmPageInclusionList)
);
